"use client";

import { CloseButton } from "@2u-landing-pages/aa/components/icons";
import React, { useEffect, useState } from "react";

export const StaticBanner = function (props: any) {
  const [showBanner, setShowBanner] = useState(true);

  const COOKIE_NAME = "reactBannerHidden";

  useEffect(() => {
    // Check for the cookie on mount
    if (typeof document !== "undefined") {
      const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
      const bannerHidden = cookies.find((cookie) => cookie.startsWith(`${COOKIE_NAME}=`));
      if (bannerHidden && bannerHidden.split("=")[1] === "true") {
        setShowBanner(false);
      }
    }
  }, []);

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    // Set cookie to hide banner for 1 year
    if (typeof document !== "undefined") {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      document.cookie = `${COOKIE_NAME}=true; expires=${expires.toUTCString()}; path=/`;
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      <style>
        {`
          .static-banner {
            position: sticky;
            top: 0;
            z-index: 100;
            background-color: ${props.backgroundColor || "#136F08"};
            padding: 12px;
            font-size: .875rem;
            font-weight: 600;
            text-align: center;
            color: white;
            text-wrap: balance;
          }

          .static-banner-content {
            padding: 0 2rem;
            margin: 0 auto;
          }

          .closeButton {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            padding: 1rem;
            color: white;
            background: none;
            border: none;
            cursor: pointer;
            outline: none;
            z-index: 100;
          }
        `}
      </style>
      <div className="static-banner">
        <div className="static-banner-content">
          We&apos;ve updated our Privacy Notice to better reflect how we collect, use and share your information. Please
          take a moment to review the{" "}
          <a
            href="https://www.getsmarter.com/privacy-policy?_gl=1*v7rdt0*_gcl_au*NjUxMTU2ODUyLjE3NDU4NTA2NzQ.&_ga=2.78554519.2080194125.1751483551-1514643554.1730142128"
            target="_blank"
            rel="noopener noreferrer"
          >
            updated notice
          </a>
          .
        </div>
        <button className="closeButton" onClick={handleClose}>
          <CloseButton />
        </button>
      </div>
    </>
  );
};
